import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Film, LineChart, FileBarChart2, LogOut, MessageSquare } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { BrandLogo } from './BrandLogo';

const navItems = [
  { to: '/app', label: 'Dashboard', icon: LayoutDashboard, roles: ['coach', 'scout', 'player'] },
  { to: '/app/players', label: 'Players', icon: Users, roles: ['coach', 'scout'] },
  { to: '/app/videos', label: 'Video Library', icon: Film, roles: ['coach', 'scout', 'player'] },
  { to: '/app/progress', label: 'Progress', icon: LineChart, roles: ['coach', 'scout', 'player'] },
  { to: '/app/reports', label: 'Reports', icon: FileBarChart2, roles: ['coach', 'scout'] },
  { to: '/app/feedback', label: 'Feedback', icon: MessageSquare, roles: ['coach', 'scout'] },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/'); };

  return (
    <aside className="hidden md:flex flex-col w-64 bg-slate-50 border-r border-slate-200 min-h-screen p-5 sticky top-0">
      <button onClick={() => navigate('/app')} className="mb-10 hover:opacity-80 transition-opacity" data-testid="sidebar-brand">
        <BrandLogo variant="inline" />
      </button>

      <nav className="flex-1 space-y-1">
        {navItems.filter(n => n.roles.includes(user?.role)).map(item => (
          <NavLink key={item.to} to={item.to} end={item.to === '/app'}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive ? 'bg-[#1e40af]/10 text-[#1e40af] border border-[#1e40af]/20' : 'text-slate-500 hover:text-[#0b1f4d] hover:bg-slate-100'
              }`}>
            <item.icon className="h-4 w-4" />
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="pt-4 border-t border-slate-200">
        <div className="flex items-center gap-3 px-2 py-2 mb-2">
          <img src={user?.avatar} alt="" className="h-9 w-9 rounded-full" />
          <div className="min-w-0">
            <div className="text-sm font-medium text-slate-900 truncate">{user?.name}</div>
            <div className="text-xs text-[#1e40af]/90 capitalize">{user?.roleLabel || user?.role}</div>
          </div>
        </div>
        <Button variant="ghost" size="sm" onClick={handleLogout} className="w-full justify-start text-slate-500 hover:text-[#0b1f4d]">
          <LogOut className="h-4 w-4 mr-2" /> Sign out
        </Button>
      </div>
    </aside>
  );
}
